import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
const SliderBlock = (props) => {
    const [active, setActive] = useState(0);
    const prevActive = usePrevious(active);
    const { index, trackedEvents, trackEvent } = props;
    useEffect(() => {
        // fix for analytics
        if (active === 0 && index && trackedEvents.indexOf('slide_viewed_1_0') === -1)
            return;
        let direction = null;
        if (prevActive !== undefined) {
            direction = active > prevActive ? 'forward' : 'backward';
        }
        trackEvent(`slide_viewed_${index}_${active}`, {
            direction,
        });
    }, [active]);
    return (_jsxs(React.Fragment, { children: [_jsx(StyledSlider, Object.assign({}, props.settings, { appendDots: (dots) => _jsx(Bullets, { children: dots }), beforeChange: (oldIndex, newIndex) => setActive(newIndex), children: props.cardArray })), _jsxs(Description, { children: [_jsxs("div", { children: [active !== null ? `${active + 1}. ` : '', active !== null ? props.cards[active].description : ''] }), _jsx("div", {})] })] }));
};
const Bullets = (props) => {
    return _jsx(BulletList, { children: props.children });
};
const StyledSlider = styled(Slider) `
  margin: 0 -16px;
  position: relative;

  .slick-track {
    margin-left: 16px;
  }
`;
const Description = styled.div `
  margin: 16px 0 24px;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
`;
const BulletSize = 7;
const BulletList = styled.div `
  display: flex;
  justify-content: center;
  margin-top: 12px;

  li {
    display: block;
    width: ${BulletSize}px;
    height: ${BulletSize}px;
    opacity: 0.3;
    margin: 0 5px;
    background: #ffffff;
    border-radius: 50%;

    button {
      display: none;
    }

    &.slick-active {
      opacity: 1;
    }
  }
`;
function usePrevious(value) {
    // The ref object is a generic container whose current property is mutable ...
    // ... and can hold any value, similar to an instance property on a class
    const ref = useRef();
    // Store current value in ref
    useEffect(() => {
        ref.current = value;
    }, [value]); // Only re-run if value changes
    // Return previous value (happens before update in useEffect above)
    return ref.current;
}
export default SliderBlock;
